export enum TYPES {
  STORE = "store",
  LIVE_CARP = "livecarp",
}

export const TYPES_NAME = {
  [TYPES.STORE]: "飼育資材ストア",
  [TYPES.LIVE_CARP]: "ライブ鯉",
};

export const TYPES_ARRAY = [
  { id: TYPES.STORE, name: TYPES_NAME[TYPES.STORE] },
  { id: TYPES.LIVE_CARP, name: TYPES_NAME[TYPES.LIVE_CARP] },
];
